import React from "react";
import { t } from "../../../../dev/helpers/translator";
import Config from "../../../config/main";
import DatePicker from "@common/components/datePicker";

export default function stackerBalanceTemplate() {
	return (
		<div className="ticket-results-view-p">
			{Config.enableMultipleDaysReport ? (
				<div className="todays-reports-popup">
					<h3>{t("Daily Report")}</h3>
					<p className="">{t("Start date")}</p>
					<DatePicker
						onlyPast
						selected={this.state.startDate}
						onChange={this.handleChange}
						selectsStart
						startDate={this.state.startDate}
						endDate={this.state.endDate}
					/>
					<p className="endDate">{t("End date")}</p>
					<DatePicker
						onlyPast
						selected={this.state.endDate}
						onChange={this.handleChangeEndDate}
						selectsEnd
						startDate={this.state.startDate}
						endDate={this.state.endDate}
						minDate={this.state.startDate}
					/>
				</div>
			) : (
				<div className="todays-reports-popup">
					<h3>{t("Daily Report")}</h3>
					<p className="">{t("Report for")}</p>
					<DatePicker
						onlyPast
						selected={this.state.startDate}
						onChange={this.handleChange}
						startDate={this.state.startDate}
						endDate={this.state.endDate}
					/>
				</div>
			)}
			<div className="buttons-view-w-t">
				<ul>
					<li>
						<div className="separator-box-buttons-m">
							<button
								className="button-view-normal-m"
								onClick={this.handleClickTodaysReport()}
							>
								{t("Print")}
							</button>
						</div>
					</li>
				</ul>
			</div>
		</div>
	);
}
